import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getInboxAccessUrl } from '../../urls/inbox-urls';
import AssigneeOptionContainer from './AssigneeOptionContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AssignToUserHeader = ({
  shouldShowTooltip = true,
  workspaceId
}) => /*#__PURE__*/_jsx(AssigneeOptionContainer, {
  children: /*#__PURE__*/_jsxs(View, {
    paddingInlineStart: "100",
    paddingInlineEnd: "200",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.reassignment.assignAnotherUser"
    }), shouldShowTooltip && workspaceId && /*#__PURE__*/_jsx(HelpIcon, {
      alignWithText: true,
      marginInlineStart: "100",
      title: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "routing-ui.reassignment.usersSectionHelp.link_jsx",
          elements: {
            Link
          },
          options: {
            external: true,
            href: getInboxAccessUrl(workspaceId)
          }
        })
      })
    })]
  })
});
AssignToUserHeader.displayName = 'AssignToUserHeader';
export default AssignToUserHeader;